import React, { FC } from 'react';

import { SharedPartnerConditionProps } from '../../PartnerRules/types';
import { SharedConditionProps } from '../../types';
import { PartnerOptionSelect } from '../components/PartnerOptionSelect';
import { PartnerSelect } from '../components/PartnerSelect';
import { PartnerStatusSelect } from '../components/PartnerStatusSelect';

export const PartnerStatusIsNot: FC<
  SharedConditionProps | SharedPartnerConditionProps
> = props => {
  return (
    <>
      {!props.setPartnerRules && <PartnerSelect {...props} />}
      <PartnerStatusSelect {...props} />
      {!props.setPartnerRules && <PartnerOptionSelect {...props} />}
    </>
  );
};
